/** Shared helpers for public partner profile pages. */

export function formatINR(n) {
  if (n === null || n === undefined || n === '' || isNaN(n)) return null;
  const num = Number(n);
  if (num >= 10000000) return `₹${(num / 10000000).toFixed(2).replace(/\.00$/, '')} Cr`;
  if (num >= 100000) return `₹${(num / 100000).toFixed(2).replace(/\.00$/, '')} L`;
  return `₹${num.toLocaleString('en-IN')}`;
}

export function priceRange(min, max) {
  const lo = formatINR(min);
  const hi = formatINR(max);
  if (lo && hi && min !== max) return `${lo} – ${hi}`;
  return lo || hi || 'Price on request';
}

export const PLACEHOLDER_PROPERTY =
  'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=70';

/** Pick a usable image URL from a listing image entry (string or object). */
export function firstImage(images, fallback = PLACEHOLDER_PROPERTY) {
  if (!images || !images.length) return fallback;
  const img = images[0];
  if (typeof img === 'string') return img;
  return img?.url || img?.medium || img?.original || img?.thumbnail || fallback;
}
